import { format } from 'd3-format'
import currenciesData from './ISOCurrencies.json'

export default function formatLabelString (value, type, currencyRegion = 'USD') {
  if (isNaN(value)) return '--'

  switch (type) {
    case 'currency':
      // Get currency symbol for the region
      const currencySymbol = currenciesData?.[currencyRegion]?.symbolNative || '$'

      const isNegative = value < 0
      if (Math.abs(value) >= 1) {
        return `${isNegative ? '-' : ''}${currencySymbol}${format('.3~s')(Math.abs(value))}`
      }
      return `${isNegative ? '-' : ''}${currencySymbol}${format('.2~')(Math.abs(value))}`
    case 'percent':
      return `${format('.2~')(value)}%`
    case 'number':
      if (Math.abs(value) < 1) return format('.2~r')(value)
      return format('.3~s')(value)
    case 'percentile':
      return `${Math.round(value)}`
    default:
      return `${value}`
  }
}